<strong class="label-title">
    e-Consent
</strong>
<div class="parcels-filter">
    <div class="parcels-filter_view-part" (click)="showDropdown = !showDropdown">
        <span *ngIf="es.filterRecipients.ignoreWaiverSettings === 1">Signed</span>
        <span *ngIf="es.filterRecipients.ignoreWaiverSettings === 0">Not Signed</span>
        <span *ngIf="es.filterRecipients.ignoreWaiverSettings === -1">All</span>
    </div>
    <div class="parcels-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox" (click)="changeFilter(-1)">
            <label class="img-checkbox">
                <span>All</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox" (click)="changeFilter(1)">
            <label class="img-checkbox">
                <span>Signed</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox" (click)="changeFilter(0)">
            <label class="img-checkbox">
                <span>Not signed</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/email/recipients-filter/recipients-filter.component.html